import { jsx as n, Fragment as M } from "react/jsx-runtime";
import * as t from "react";
import { m as I } from "../node_modules/streamdown/dist/chunk-RLXIAIE6.js";
import { Renderer as j } from "../node_modules/@openuidev/react-lang/dist/Renderer.js";
import "../node_modules/@openuidev/react-lang/dist/parser/types.js";
import "../node_modules/@openuidev/react-lang/dist/context.js";
import "../node_modules/@openuidev/react-lang/dist/hooks/useFormValidation.js";
import { useCopilotInstruction as U } from "./global-state.js";
const d = t.createContext(null), p = t.createContext(null), m = t.createContext(!1);
function G({
  children: o,
  markdown: r,
  library: e,
  libraryPromptOptions: s,
  approval: f
}) {
  const a = t.useMemo(() => {
    const u = {}, { code: C = D, pre: v = B, ...x } = r ?? {};
    Object.assign(u, x);
    const w = v, k = C;
    return u.pre = function({ children: i, ...c }) {
      return e != null && (i?.props?.className ?? "") === "language-openui" ? /* @__PURE__ */ n(M, { children: i }) : /* @__PURE__ */ n(w, { ...c, children: i });
    }, u.code = function({ className: c, children: l, ...P }) {
      return c === "language-openui" && e != null ? /* @__PURE__ */ n(Y, { response: l, library: e }) : /* @__PURE__ */ n(k, { ...P, className: c, children: l });
    }, u;
  }, [r, e]), g = t.useMemo(() => {
    const u = e != null ? e.prompt({
      ...s,
      preamble: "When rendering UI, emit an `openui` code fence. Inside the fence, write valid openui-lang. Everything outside the fence is regular markdown."
    }) : null;
    return [
      "## Content Guidelines",
      "",
      "1. You have access to github flavored markdown. Lean on it to make your responses more readable and engaging.",
      ...u != null ? [
        "2. You can also render rich UI components inline using an `openui` code fence. When you do, the fence content must be valid openui-lang — all syntax rules, component signatures, and streaming guidelines below apply to what goes inside the fence. Your prose outside the fence should remain standard markdown.",
        "",
        u
      ] : []
    ].join(`
`);
  }, [e, s]);
  U({ instruction: g });
  const h = t.useMemo(() => ({ components: a }), [a]);
  return /* @__PURE__ */ n(d.Provider, { value: h, children: /* @__PURE__ */ n(p.Provider, { value: f ?? null, children: o }) });
}
function Y({ response: o, library: r }) {
  const e = t.useContext(m);
  return /* @__PURE__ */ n(j, { response: o.trim(), library: r, isStreaming: e });
}
function L() {
  return t.useContext(p);
}
function O({
  children: o,
  isAnimating: r = !1,
  animated: e
}) {
  const s = t.useContext(d);
  if (s == null)
    throw new Error("Markdown must be used within CopilotProvider");
  return /* @__PURE__ */ n(m.Provider, { value: r ?? !1, children: /* @__PURE__ */ n(I, { components: s.components, animated: e, isAnimating: r, children: o }) });
}
function B(o) {
  return /* @__PURE__ */ n("pre", { ...o });
}
function D(o) {
  return /* @__PURE__ */ n("code", { ...o });
}
export {
  G as CopilotProvider,
  O as Markdown,
  L as useCopilotApproval
};
